export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'
export const SET_QUIZ_SESSION_TOKEN = 'SET_QUIZ_SESSION_TOKEN'
export const DELETE_USER = 'DELETE_USER'
export const SET_USER_PERMISSION = 'SET_USER_PERMISSION'
export const SET_VIDEO = 'SET_VIDEO'
export const SET_VIDEO_SECONDS_STOPPED = 'SET_VIDEO_SECONDS_STOPPED'
export const DELETE_VIDEO = 'DELETE_VIDEO'
export const DELETE_VIDEO_SECONDS_STOPPED = 'DELETE_VIDEO_SECONDS_STOPPED'

export const SET_PUBLIC_COURSE_SEARCH = 'SET_PUBLIC_COURSE_SEARCH'
export const SET_PUBLIC_COURSE_ENTER = 'SET_PUBLIC_COURSE_ENTER'
export const DELETE_PUBLIC_COURSE_ENTER = 'DELETE_PUBLIC_COURSE_ENTER'
